import { cmsBaseUrl } from '../../config/GlobalConfig';
import { MAX_SMALL_MOBILE_WIDTH } from '../../const/AppConst';
import useWindowDimensions from '../../hooks/useWindowDimensions';
export default function FooterBloc() {

    const {width} = useWindowDimensions();
    const isMobile = width <= MAX_SMALL_MOBILE_WIDTH;

    const listClassName = isMobile ? "list-bullet": "list-inline-bullet";


    return (
        <div className="bg-glace p-y-md m-y-xl">
            <div className="grid">
                <div className="col-start-1 col-md-end-7 col-lg-start-5 col-lg-end-12 col-md-end-7 col-end-4 ta-center secondary-footer">
                    <p className="fz-sm">MGP - {new Date().getFullYear()} Tous droits réservés.</p>
                    <ul className={listClassName}>
                        <li className="fz-sm">
                            <a href={cmsBaseUrl + "/sites/mgp/home/espace-emploi.html"} title="Recrutement">
                        <span className={listClassName}>Recrutement</span></a></li>
                        <li className="fz-sm">
                            <a href={cmsBaseUrl + "/sites/mgp/home/plan-du-site.html"} title="Plan du site">Plan du site</a>
                        </li>
                        <li className="fz-sm">
                            <a href={cmsBaseUrl + "/sites/mgp/home/mentions-legales-1.html"} title="Mentions légales">Mentions légales</a>
                        </li>
                        <li className="fz-sm">
                            <a href={cmsBaseUrl + "/sites/mgp/home/mentions-legales.html"} title="Politique données personnelles">
                                Politique données personnelles
                            </a>
                        </li>
                        <li className="fz-sm">
                            <a href={cmsBaseUrl + "/sites/mgp/home/gestion-des-cookies.html"} title="Gestion des cookies">Gestion des cookies</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="m-y-xl"></div>
        </div>
        
  )
}


